<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Login</p>
      <b-button type="button" icon-left="close" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <form @keydown.enter="login()">
        <b-field label="Username" label-position="inside">
          <b-input v-model="username"></b-input>
        </b-field>
        <b-field label="Password" label-position="inside">
          <b-input type="password" v-model="password"></b-input>
        </b-field>
        <b-button @click="login()" type="is-success" class="mb-1" expanded>Login</b-button>
        <b-button @click="openRegister()" expanded type="is-text">I don't have an account</b-button>
      </form>
    </section>
    <footer class="modal-card-foot">
    </footer>
  </div>
</template>
<script>
import ApiService from '../common/api.service'
import { USER_LOGIN, USER_INIT } from '../store/User/action.type'
import Register from './Register.vue'

export default {
  data() {
    return {
      username: null,
      password: null
    }
  },
  methods: {
    async login() {
      const response = await this.$store.dispatch(USER_LOGIN, { username: this.username, password: this.password })
      if (response.status == 201) {
        await this.$store.dispatch(USER_INIT)
        this.$emit('close')
      }
    },
    openRegister() {
      this.$emit('close')
      this.$buefy.modal.open({
        parent: this,
        component: Register,
        hasModalCard: true,
        trapFocus: true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
